import type React from 'react';

import { Button } from '@change/ds-core-ui';

import { useShouldShowSharingGoalFlow } from '#src/app/pages/psf/share/shared/hooks';

import { usePageFooter } from './hooks/usePageFooter';

export const PageFooter: React.FC = () => {
	const shouldShowSharingGoalFlow = useShouldShowSharingGoalFlow();
	const {
		data: { skipLabel, skipUrl },
		actions: { handleSkipClick },
	} = usePageFooter();

	// The sharing-goal flow renders its own "Skip for now" link inside the card,
	// so the standalone footer skip would be a duplicate.
	if (shouldShowSharingGoalFlow) return null;

	return (
		<div className="px-4 py-7 text-center md:mt-5">
			<Button
				as="a"
				href={skipUrl}
				onClick={handleSkipClick}
				data-qa="skip-link"
				variant="tertiary"
				size="large"
				className="self-center"
			>
				{skipLabel}
			</Button>
		</div>
	);
};
